import React, { useEffect, useState } from "react";
import axios from "axios";
import { useParams, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import BorrowerBinder from "./BorrowerBinder";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Admin view of a borrower's Electronic Pre-Closing Binder — read-only, printable.
export default function AdminBinder() {
  const { appId } = useParams();
  const navigate = useNavigate();
  const [app, setApp] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    let alive = true;
    (async () => {
      try {
        const r = await axios.get(`${API}/borrower/applications/${appId}`);
        if (alive) setApp(r.data.application);
      } catch (e) {
        if (alive) setError(e?.response?.data?.detail || "Unable to load binder.");
      }
    })();
    return () => { alive = false; };
  }, [appId]);

  if (error) {
    return (
      <div className="min-h-screen bg-[#1a1a14] text-[#ECECE4] flex items-center justify-center p-8" data-testid="admin-binder-error">
        <div className="text-center">
          <div className="text-[#FF8585] mb-3">{error}</div>
          <button onClick={() => navigate("/admin")} className="text-[#B8860B] text-sm underline" data-testid="admin-binder-back">← Back to dashboard</button>
        </div>
      </div>
    );
  }

  if (!app) {
    return (
      <div className="min-h-screen bg-[#1a1a14] text-[#ECECE4] flex items-center justify-center" data-testid="admin-binder-loading">
        <Loader2 className="animate-spin" />
      </div>
    );
  }

  return (
    <BorrowerBinder
      binder={app.binder}
      signatures={app.signatures || []}
      titleAccepted={!!app.title_accepted}
      onBack={() => navigate("/admin")}
    />
  );
}
